import * as v101 from '@icoach/documents/membership/create/versions/v101/notice';
import * as v102 from '@icoach/documents/membership/create/versions/v102/notice';
import * as v103 from '@icoach/documents/membership/create/versions/v103/notice';
import * as v104 from '@icoach/documents/membership/create/versions/v104/notice';
import * as v105 from '@icoach/documents/membership/create/versions/v105/notice';
import * as v106 from '@icoach/documents/membership/create/versions/v106/notice';
import { MEMBERSHIP_CONTRACT_VERSION } from '@icoach/constants/dataEnums';

// key 一律用具名常數，不用裸數字，避免版本代號散落各處。
const VERSION_REGISTRY = {
    [MEMBERSHIP_CONTRACT_VERSION.MEMBERSHIP2017]: v101,
    [MEMBERSHIP_CONTRACT_VERSION.MEMBERSHIP2022]: v102,
    [MEMBERSHIP_CONTRACT_VERSION.Membership202310]: v103,
    [MEMBERSHIP_CONTRACT_VERSION.Membership202501]: v104,
    [MEMBERSHIP_CONTRACT_VERSION.Membership202510]: v105,
    [MEMBERSHIP_CONTRACT_VERSION.Membership202610]: v106,
};

// 依合約版本（contractVersion，可為數字或數字字串）取出對應版本模組
// （模組具名匯出 { default: 原始資料, getNotice: (membershipType, memberType) => [...] }）。
// 找不到版本時拋錯：原本 contractVersion 不在已知鍵值中就會在存取巢狀資料時噴 TypeError，
// 這裡改用清楚訊息的 Error，行為定位不變（未知版本一樣無法正常運作）。
export const resolveVersion = (contractVersion) => {
    const versionModule = VERSION_REGISTRY[contractVersion];
    if (!versionModule) {
        throw new Error(`未知的合約版本：${contractVersion}`);
    }
    return versionModule;
};

// 該版本的個資告知落在 contractSurvey.items 的哪一格；沒有個資卡片（101-105）或版本未知時回傳 null。
// 給換頁卡控用：呼叫端在資料還沒載入時就會問一次，故未知版本回 null 而非拋錯（與 resolveVersion 的行為刻意不同）。
export const resolvePrivacyItemIndex = (contractVersion) => VERSION_REGISTRY[contractVersion]?.PRIVACY_ITEM_INDEX ?? null;
